import axios, { AxiosProgressEvent } from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

export interface Import {
  id: string;
  fileName: string;
  filePath: string;
  status: string;
  createdAt: string;
}

export const fetchAll = async (): Promise<Import[]> => {
  const response = await axios.get(
    `${process.env.REACT_APP_CONTACTS_SVC_URL}/imports`
  );
  return response.data;
};

export const createImport = async (
  file: File,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
): Promise<Import> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post(
    `${process.env.REACT_APP_CONTACTS_SVC_URL}/imports`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    }
  );
  return response.data;
};
